/**
 * @fileoverview CommentRenderer component for the Storyteller web application.
 * Displays a comment with a text from the JSON schema.
 *
 * @example
 * // Basic usage
 * <CommentRenderer schema={schema} uischema={uischema} />
 */

import { LabelProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { VanillaRendererProps, withVanillaControlProps } from '@jsonforms/vanilla-renderers'
import { useTranslation } from 'react-i18next'
import { Comment } from '../../../typography/Typography'

/**
 * @function CommentRenderer
 * @description Component for rendering a comment with a text from the JSON schema.
 * @param {LabelProps & VanillaRendererProps} props - The props for the CommentRenderer component.
 * @returns {JSX.Element} The CommentRenderer component.
 */
function CommentRenderer(props: LabelProps & VanillaRendererProps) {
    const { t } = useTranslation()
    return <Comment comment={t(props.text)} />
}

export const CommentTester = rankWith(4, uiTypeIs('Comment'))

export default withVanillaControlProps(withJsonFormsLabelProps(CommentRenderer))
